import { createContext, useContext, useState } from "react";

export const PLANS = [
  { id: "essentiel", hours: 5, mo: 450, c3: 399, total: 14364 },
  { id: "professionnel", hours: 10, mo: 850, c3: 749, total: 26964, featured: true },
  { id: "premium", hours: 20, mo: 1600, c3: 1399, total: 50364 },
];

const LOCALES = { fr: "fr-CA", en: "en-CA", pt: "pt-BR" };

export const money = (n, lang) => {
  const s = Number(n).toLocaleString(LOCALES[lang]);
  if (lang === "fr") return `${s} $`;
  if (lang === "en") return `$${s}`;
  return `CA$ ${s}`;
};

const fr = {
  nav: { services: "Services", pricing: "Forfaits", advantages: "Avantages", terms: "Conditions", join: "Adhérer", admin: "Admin" },
  hero: {
    eyebrow: "Entente de soutien technique",
    lines: ["Votre site,", "vos données,", "votre infra."],
    accent: "Sous contrôle.",
    lead: "bsys. prend en charge votre site Web, votre base de données et votre infrastructure — avec un soutien technique continu.",
    cta: "Nos services",
    cta2: "Demander l'adhésion",
    stats: [["~11 %", "de moins qu'en sans engagement"], ["≤ 3 %", "indexation annuelle plafonnée"], ["36", "mois de prix stable"]],
    frame: "Site Web · Base de données · Infrastructure",
    scroll: "Défiler",
  },
  marquee: ["Site Web", "Base de données", "Infrastructure", "Soutien", "Surveillance", "Sauvegardes", "Certificats SSL", "Mises à jour de sécurité"],
  services: {
    label: "01 — Services couverts",
    title: "Un seul forfait d'heures. Quatre territoires.",
    sub: "Les heures de chaque forfait peuvent servir à l'ensemble des services suivants.",
    items: [
      { k: "web", t: "Site Web", d: "Mises à jour de contenu, corrections, améliorations et nouvelles fonctionnalités." },
      { k: "db", t: "Base de données", d: "Sauvegardes, maintenance, optimisation des requêtes et ajustements au panneau d'administration." },
      { k: "infra", t: "Infrastructure", d: "Hébergement, DNS, certificats SSL, courriel, surveillance de la disponibilité et mises à jour de sécurité." },
      { k: "support", t: "Soutien", d: "Réponse aux demandes par courriel ou téléphone et conseils techniques." },
    ],
  },
  pricing: {
    label: "02 — Forfaits",
    title: "Choisissez votre cadence.",
    sub: "L'engagement de 3 ans garantit un tarif réduit d'environ 11 % et un prix stable pendant toute la durée de l'entente.",
    t36: "Engagement 3 ans",
    tnone: "Sans engagement",
    save: "−11 %",
    perMonth: "/ mois",
    hours: "h / mois",
    response: "Délai de réponse",
    total: "Total 36 mois",
    insteadOf: "au lieu de",
    monthToMonth: "Mois à mois, résiliable",
    popular: "Le plus choisi",
    choose: "Choisir ce forfait",
    note: "Montants en dollars canadiens ; taxes applicables en sus, le cas échéant.",
    plans: {
      essentiel: { name: "Essentiel", resp: "2 jours ouvrables", desc: "Surveillance, sauvegardes, mises à jour de sécurité, DNS et petits ajustements de contenu." },
      professionnel: { name: "Professionnel", resp: "1 jour ouvrable", desc: "Tout l'Essentiel, plus les améliorations au site, les ajustements à la base de données et au panneau d'administration, et un rapport mensuel." },
      premium: { name: "Premium", resp: "Même jour (prioritaire)", desc: "Tout le Professionnel, plus le développement de nouvelles fonctionnalités et un service prioritaire." },
    },
  },
  adv: {
    label: "03 — Avantages de l'engagement",
    title: "Trois ans. Cinq garanties.",
    items: [
      ["−11 %", "Économie", "Environ 11 % de moins chaque mois que le tarif sans engagement."],
      ["≤ 3 %", "Prix protégé", "Indexation annuelle plafonnée à 3 %, quelle que soit l'inflation."],
      ["1× / an", "Flexibilité", "Changement de forfait possible une fois par année, à la hausse ou à la baisse."],
      ["50 %", "Report d'heures", "Les heures non utilisées sont reportées au mois suivant, jusqu'à un maximum de 50 % du forfait."],
      ["90 $", "Tarif préférentiel", "Heures excédentaires à 90 $ CA au lieu de 100 $ CA."],
    ],
  },
  terms: {
    label: "04 — Conditions",
    title: "Les petits caractères, en grand.",
    conditions: "Conditions",
    payment: "Paiement et facturation",
    c: [
      ["Durée", "36 mois à compter de la date de signature."],
      ["Heures excédentaires", "90 $ CA l'heure, facturées le mois suivant, après approbation du client."],
      ["Urgences hors heures ouvrables", "Majoration de 50 % (soirs, fins de semaine et jours fériés)."],
      ["Frais de tiers", "Nom de domaine, hébergement payant, base de données et courriel sont facturés au coût réel, en sus du forfait."],
      ["Indexation", "À chaque anniversaire de l'entente, plafonnée à 3 %."],
      ["Changement de forfait", "Une fois par année, avec un préavis de 30 jours."],
      ["Résiliation anticipée", "Possible avec un préavis de 60 jours et une indemnité de 3 mois du forfait en vigueur."],
      ["Renouvellement", "À l'échéance, l'entente se poursuit de mois en mois au tarif sans engagement, sauf nouvelle entente."],
    ],
    p: [
      ["Facturation", "Facture émise le 1er de chaque mois, payable dans les 15 jours."],
      ["Devise et taxes", "Montants en dollars canadiens ; taxes applicables en sus, le cas échéant."],
      ["Mode de paiement", "Paiement par virement bancaire international ou par Wise."],
      ["Retard de paiement", "Retard de plus de 30 jours : suspension des services jusqu'au règlement."],
    ],
  },
  form: {
    label: "05 — Contact",
    title: "Parlons de votre projet.",
    sub: "Décrivez votre besoin en quelques lignes : nous vous revenons rapidement avec une proposition.",
    name: "Nom complet", company: "Entreprise", email: "Courriel", phone: "Téléphone (facultatif)",
    plan: "Forfait choisi", commitment: "Formule", message: "Message (facultatif)",
    submit: "Envoyer la demande d'adhésion", sending: "Envoi…",
    okTitle: "Demande reçue.", okText: "Merci ! Regis Bermudez vous contactera sous peu.", again: "Nouvelle demande",
    error: "Impossible d'envoyer la demande. Vérifiez les champs et réessayez.",
    provider: "Fournisseur", contact: "Contact",
  },
  footer: { rights: "Tous droits réservés.", top: "Retour en haut", tag: "Soutien technique Web, données et infrastructure." },
};

const en = {
  nav: { services: "Services", pricing: "Plans", advantages: "Benefits", terms: "Terms", join: "Sign up", admin: "Admin" },
  hero: {
    eyebrow: "Technical support agreement",
    lines: ["Your website,", "your data,", "your infra."],
    accent: "Under control.",
    lead: "bsys. takes care of your website, database and infrastructure — with ongoing technical support.",
    cta: "Our services",
    cta2: "Request to join",
    stats: [["~11%", "less than no-commitment pricing"], ["≤ 3%", "annual indexation cap"], ["36", "months of stable pricing"]],
    frame: "Website · Database · Infrastructure",
    scroll: "Scroll",
  },
  marquee: ["Website", "Database", "Infrastructure", "Support", "Monitoring", "Backups", "SSL certificates", "Security updates"],
  services: {
    label: "01 — Covered services",
    title: "One bank of hours. Four territories.",
    sub: "Each plan's hours can be used across all of the following services.",
    items: [
      { k: "web", t: "Website", d: "Content updates, fixes, improvements and new features." },
      { k: "db", t: "Database", d: "Backups, maintenance, query optimization and admin panel adjustments." },
      { k: "infra", t: "Infrastructure", d: "Hosting, DNS, SSL certificates, email, uptime monitoring and security updates." },
      { k: "support", t: "Support", d: "Answers to requests by email or phone, and technical advice." },
    ],
  },
  pricing: {
    label: "02 — Plans",
    title: "Pick your cadence.",
    sub: "The 3-year commitment guarantees a rate about 11% lower and a stable price for the whole agreement.",
    t36: "3-year commitment",
    tnone: "No commitment",
    save: "−11%",
    perMonth: "/ month",
    hours: "h / month",
    response: "Response time",
    total: "36-month total",
    insteadOf: "instead of",
    monthToMonth: "Month to month, cancel anytime",
    popular: "Most chosen",
    choose: "Choose this plan",
    note: "Amounts in Canadian dollars; applicable taxes extra, where applicable.",
    plans: {
      essentiel: { name: "Essential", resp: "2 business days", desc: "Monitoring, backups, security updates, DNS and small content tweaks." },
      professionnel: { name: "Professional", resp: "1 business day", desc: "Everything in Essential, plus site improvements, database and admin panel adjustments, and a monthly report." },
      premium: { name: "Premium", resp: "Same day (priority)", desc: "Everything in Professional, plus new feature development and priority service." },
    },
  },
  adv: {
    label: "03 — Commitment benefits",
    title: "Three years. Five guarantees.",
    items: [
      ["−11%", "Savings", "About 11% less every month than the no-commitment rate."],
      ["≤ 3%", "Price protection", "Annual indexation capped at 3%, whatever inflation does."],
      ["1× / yr", "Flexibility", "Switch plans once a year, up or down."],
      ["50%", "Hour rollover", "Unused hours roll over to the next month, up to 50% of the plan."],
      ["$90", "Preferred rate", "Extra hours at CA$90 instead of CA$100."],
    ],
  },
  terms: {
    label: "04 — Terms",
    title: "The fine print, in large type.",
    conditions: "Conditions",
    payment: "Payment & billing",
    c: [
      ["Term", "36 months from the signing date."],
      ["Extra hours", "CA$90 per hour, billed the following month, after client approval."],
      ["After-hours emergencies", "50% surcharge (evenings, weekends and holidays)."],
      ["Third-party fees", "Domain name, paid hosting, database and email are billed at actual cost, on top of the plan."],
      ["Indexation", "On each anniversary of the agreement, capped at 3%."],
      ["Plan change", "Once a year, with 30 days' notice."],
      ["Early termination", "Possible with 60 days' notice and a fee of 3 months of the current plan."],
      ["Renewal", "At term, the agreement continues month to month at the no-commitment rate, unless a new agreement is signed."],
    ],
    p: [
      ["Invoicing", "Invoice issued on the 1st of each month, payable within 15 days."],
      ["Currency & taxes", "Amounts in Canadian dollars; applicable taxes extra, where applicable."],
      ["Payment method", "International bank transfer or Wise."],
      ["Late payment", "More than 30 days late: services suspended until settled."],
    ],
  },
  form: {
    label: "05 — Contact",
    title: "Let's talk about your project.",
    sub: "Tell us what you need in a few lines and we'll get back to you quickly with a proposal.",
    name: "Full name", company: "Company", email: "Email", phone: "Phone (optional)",
    plan: "Chosen plan", commitment: "Option", message: "Message (optional)",
    submit: "Send sign-up request", sending: "Sending…",
    okTitle: "Request received.", okText: "Thank you! Regis Bermudez will contact you shortly.", again: "New request",
    error: "Could not send the request. Check the fields and try again.",
    provider: "Provider", contact: "Contact",
  },
  footer: { rights: "All rights reserved.", top: "Back to top", tag: "Technical support for web, data and infrastructure." },
};

const pt = {
  nav: { services: "Serviços", pricing: "Planos", advantages: "Vantagens", terms: "Condições", join: "Aderir", admin: "Admin" },
  hero: {
    eyebrow: "Contrato de suporte técnico",
    lines: ["Seu site,", "seus dados,", "sua infra."],
    accent: "Sob controle.",
    lead: "A bsys. cuida do seu site, do seu banco de dados e da sua infraestrutura — com suporte técnico contínuo.",
    cta: "Nossos serviços",
    cta2: "Solicitar adesão",
    stats: [["~11%", "a menos que sem fidelidade"], ["≤ 3%", "reajuste anual limitado"], ["36", "meses de preço estável"]],
    frame: "Site · Banco de dados · Infraestrutura",
    scroll: "Rolar",
  },
  marquee: ["Site", "Banco de dados", "Infraestrutura", "Suporte", "Monitoramento", "Backups", "Certificados SSL", "Atualizações de segurança"],
  services: {
    label: "01 — Serviços cobertos",
    title: "Um pacote de horas. Quatro frentes.",
    sub: "As horas de cada plano podem ser usadas em todos os serviços abaixo.",
    items: [
      { k: "web", t: "Site", d: "Atualizações de conteúdo, correções, melhorias e novas funcionalidades." },
      { k: "db", t: "Banco de dados", d: "Backups, manutenção, otimização de consultas e ajustes no painel administrativo." },
      { k: "infra", t: "Infraestrutura", d: "Hospedagem, DNS, certificados SSL, e-mail, monitoramento de disponibilidade e atualizações de segurança." },
      { k: "support", t: "Suporte", d: "Atendimento por e-mail ou telefone e consultoria técnica." },
    ],
  },
  pricing: {
    label: "02 — Planos",
    title: "Escolha seu ritmo.",
    sub: "A fidelidade de 3 anos garante uma tarifa cerca de 11% menor e preço estável durante todo o contrato.",
    t36: "Fidelidade 3 anos",
    tnone: "Sem fidelidade",
    save: "−11%",
    perMonth: "/ mês",
    hours: "h / mês",
    response: "Prazo de resposta",
    total: "Total 36 meses",
    insteadOf: "em vez de",
    monthToMonth: "Mês a mês, cancelável",
    popular: "Mais escolhido",
    choose: "Escolher este plano",
    note: "Valores em dólares canadenses; impostos aplicáveis à parte, quando houver.",
    plans: {
      essentiel: { name: "Essencial", resp: "2 dias úteis", desc: "Monitoramento, backups, atualizações de segurança, DNS e pequenos ajustes de conteúdo." },
      professionnel: { name: "Profissional", resp: "1 dia útil", desc: "Tudo do Essencial, mais melhorias no site, ajustes no banco de dados e no painel administrativo, e um relatório mensal." },
      premium: { name: "Premium", resp: "Mesmo dia (prioritário)", desc: "Tudo do Profissional, mais desenvolvimento de novas funcionalidades e atendimento prioritário." },
    },
  },
  adv: {
    label: "03 — Vantagens da fidelidade",
    title: "Três anos. Cinco garantias.",
    items: [
      ["−11%", "Economia", "Cerca de 11% a menos por mês que a tarifa sem fidelidade."],
      ["≤ 3%", "Preço protegido", "Reajuste anual limitado a 3%, independentemente da inflação."],
      ["1× / ano", "Flexibilidade", "Troca de plano uma vez por ano, para cima ou para baixo."],
      ["50%", "Horas acumuladas", "Horas não usadas passam para o mês seguinte, até 50% do plano."],
      ["CA$ 90", "Tarifa preferencial", "Horas excedentes a CA$ 90 em vez de CA$ 100."],
    ],
  },
  terms: {
    label: "04 — Condições",
    title: "As letras miúdas, em tamanho grande.",
    conditions: "Condições",
    payment: "Pagamento e faturamento",
    c: [
      ["Duração", "36 meses a partir da data de assinatura."],
      ["Horas excedentes", "CA$ 90 por hora, faturadas no mês seguinte, após aprovação do cliente."],
      ["Urgências fora do horário", "Acréscimo de 50% (noites, fins de semana e feriados)."],
      ["Custos de terceiros", "Domínio, hospedagem paga, banco de dados e e-mail são cobrados pelo custo real, além do plano."],
      ["Reajuste", "A cada aniversário do contrato, limitado a 3%."],
      ["Troca de plano", "Uma vez por ano, com aviso prévio de 30 dias."],
      ["Rescisão antecipada", "Possível com aviso prévio de 60 dias e multa de 3 meses do plano vigente."],
      ["Renovação", "No vencimento, o contrato continua mês a mês na tarifa sem fidelidade, salvo novo acordo."],
    ],
    p: [
      ["Faturamento", "Fatura emitida no dia 1º de cada mês, com vencimento em 15 dias."],
      ["Moeda e impostos", "Valores em dólares canadenses; impostos aplicáveis à parte, quando houver."],
      ["Forma de pagamento", "Transferência bancária internacional ou Wise."],
      ["Atraso", "Atraso superior a 30 dias: suspensão dos serviços até a regularização."],
    ],
  },
  form: {
    label: "05 — Contato",
    title: "Vamos falar do seu projeto.",
    sub: "Descreva o que você precisa em poucas linhas e retornaremos rapidamente com uma proposta.",
    name: "Nome completo", company: "Empresa", email: "E-mail", phone: "Telefone (opcional)",
    plan: "Plano escolhido", commitment: "Modalidade", message: "Mensagem (opcional)",
    submit: "Enviar solicitação de adesão", sending: "Enviando…",
    okTitle: "Solicitação recebida.", okText: "Obrigado! Regis Bermudez entrará em contato em breve.", again: "Nova solicitação",
    error: "Não foi possível enviar. Verifique os campos e tente novamente.",
    provider: "Fornecedor", contact: "Contato",
  },
  footer: { rights: "Todos os direitos reservados.", top: "Voltar ao topo", tag: "Suporte técnico para web, dados e infraestrutura." },
};

const DICT = { fr, en, pt };
const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("bsys-lang") || "fr");
  const setLang = (l) => {
    localStorage.setItem("bsys-lang", l);
    document.documentElement.lang = l;
    setLangState(l);
  };
  return <LangCtx.Provider value={{ lang, setLang, t: DICT[lang] || fr }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
